(() => {
  const node = document.getElementById('ma-locale-memory-context');
  if (!node) return;
  const context = JSON.parse(node.textContent);
  const roots = context.languages;
  const countries = new Set(context.countries);
  const key = context.draft ? `ma-locale-choice:preview:${context.theme}` : 'ma-locale-choice';
  const url = new URL(location.href);
  const locales = Object.keys(roots);
  const prefixes = locales.filter(code => roots[code] !== '/').sort((a, b) => roots[b].length - roots[a].length);
  const pathLocale = path => prefixes.find(code => path === roots[code] || path.startsWith(roots[code] + '/'));
  const barePath = path => {
    const code = pathLocale(path);
    return code ? path.slice(roots[code].length) || '/' : path;
  };
  const localPath = (path, language) => {
    const root = roots[language].replace(/\/$/, '');
    const bare = barePath(path);
    return root + (bare === '/' ? '' : bare) || '/';
  };
  const allowedPath = path => /^\/(?:collections|products|pages|blogs|search|cart|policies|account)(?:\/|$)/.test(path) || path === '/';
  const valid = choice => choice && locales.includes(choice.language) && countries.has(choice.country) && Number.isFinite(choice.savedAt) && Date.now() - choice.savedAt < 365 * 86400000;
  const read = () => { try { const choice = JSON.parse(localStorage.getItem(key)); return valid(choice) ? choice : null; } catch { return null; } };
  const save = choice => { try { localStorage.setItem(key, JSON.stringify({...choice, savedAt:Date.now()})); } catch {} };
  const preview = target => { if (context.draft) target.searchParams.set('preview_theme_id', context.theme); };
  const currentCountry = countries.has(url.searchParams.get('country')) ? url.searchParams.get('country') : context.country;
  let selected = {language:context.language, country:currentCountry};
  const stored = read();
  const explicitLocale = pathLocale(url.pathname);
  const excluded = !allowedPath(barePath(url.pathname));
  if (excluded) return;
  if (stored && !explicitLocale && !url.searchParams.has('country') && (stored.language !== context.language || stored.country !== context.country)) {
    const destination = new URL(url);
    destination.pathname = localPath(url.pathname, stored.language);
    destination.searchParams.set('country', stored.country);
    preview(destination);
    const attempt = `${key}:restore:${stored.language}:${stored.country}:${destination.pathname}`;
    let attempted = false;
    try { attempted = sessionStorage.getItem(attempt) === '1'; sessionStorage.setItem(attempt, '1'); } catch {}
    if (!attempted) {
      const form = document.createElement('form');
      form.method = 'POST'; form.action = '/localization';
      for (const [name, value] of Object.entries({form_type:'localization', _method:'put', language_code:stored.language, country_code:stored.country, return_to:destination.pathname + destination.search + destination.hash})) {
        const input = document.createElement('input'); input.type = 'hidden'; input.name = name; input.value = value; form.append(input);
      }
      document.body.append(form); form.submit(); return;
    }
  }
  try { sessionStorage.removeItem(`${key}:restore:${context.language}:${context.country}:${url.pathname}`); } catch {}
  save(selected);
  const rewrite = link => {
    const raw = link.getAttribute('href');
    if (!raw || raw.startsWith('#') || link.hasAttribute('download') || link.hasAttribute('hreflang') || link.closest('ma-language-choice')) return;
    let target;
    try { target = new URL(raw, location.href); } catch { return; }
    if (target.origin !== location.origin || !allowedPath(barePath(target.pathname))) return;
    target.pathname = localPath(target.pathname, selected.language);
    target.searchParams.set('country', selected.country);
    preview(target);
    const value = target.pathname + target.search + target.hash;
    if (raw !== value) link.setAttribute('href', value);
  };
  const scan = root => { if (root.matches?.('a[href]')) rewrite(root); root.querySelectorAll?.('a[href]').forEach(rewrite); };
  scan(document);
  new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(scan))).observe(document.documentElement, {childList:true, subtree:true});
  document.addEventListener('click', event => { const link = event.target.closest?.('a[href]'); if (link) rewrite(link); }, {capture:true});
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !new URL(form.action, location.href).pathname.endsWith('/localization')) return;
    const language = event.submitter?.name === 'language_code' ? event.submitter.value : form.querySelector('[name="language_code"]')?.value || context.language;
    const country = event.submitter?.name === 'country_code' ? event.submitter.value : form.querySelector('[name="country_code"]')?.value || selected.country;
    if (!locales.includes(language) || !countries.has(country)) return;
    selected = {language, country}; save(selected);
    const destination = new URL(location.href);
    destination.pathname = localPath(destination.pathname, language);
    destination.searchParams.set('country', country);
    destination.hash = '';
    preview(destination);
    form.querySelectorAll('[name="return_to"]').forEach(input => { input.value = destination.pathname + destination.search; });
  }, {capture:true});
})();
